
export default {
    name: 'CardsComponent',
}
